export default __webpack_public_path__ + "pi1-1QAAT/components/BorrowerCards/images/avatar-b9b5831f977396fd75140f34ed66572e.svg";